import React from 'react'

export default function Testimonials() {
  const testimonials = [
    {
      treatment: "Uklanjanje dlačica",
      rating: 5,
      text: "Već nakon prvog tretmana vidljivi su nevjerojatni rezultati… nema više uraslih dlačica, iritacija od stalnog brijanja, a dlačica jednostavno nema. Svima preporučujem MediSpu i Danielu… ugodna atmosfera i profesionalni, sigurni tretmani."
    },
    {
      treatment: "Ožiljci od akni",
      rating: 5,
      text: "Iskreno preporučujem ovo mjesto! Nakon godina borbe s ožiljcima od akni, MediSpa mi je doslovno promijenila život. Otišla sam na mikroneedling i rezultati su nevjerojatni… već nakon samo dva tretmana ožiljci su minimalni, a koža vidljivo glađa… Daniela je profesionalna i iznimno ljubazna."
    },
    {
      treatment: "Uklanjanje tetovaža",
      rating: 5,
      text: "Počela sam s laserskim uklanjanjem tetovaže… otkrila sam pravo mjesto za opuštanje… Masaže su fantastične, a Danijela je profesionalna, staložena… osoba s kojom bi poželjeli otići na kavu."
    },
    {
      treatment: "Gljivice nokta",
      rating: 5,
      text: "Imala sam dugogodišnji problem s gljivicama nokta, ali nakon nekoliko laserskih tretmana u ovom salonu infekcija se značajno povukla, a nokti sada izgledaju zdravo. Iskreno preporučujem."
    }
  ]

  return (
    <section className="py-20 px-6 md:px-12 lg:px-20 bg-white animate-on-scroll testimonials">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-light mb-12 text-[#2c3424] text-center">
          Što kažu naši klijenti
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm font-medium text-[#2c3424] uppercase tracking-wide">
                  {testimonial.treatment}
                </span>
                <div className="flex text-yellow-500">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i}>★</span>
                  ))}
                </div>
              </div>
              <p className="text-[#1a1a1a] leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
